import { FontFaceTheme } from '@kite-js/theme-types';
import families from './families';

const mallory: FontFaceTheme = {
    fontFamily: families.mallory,
    fontFaces: [
        {
            primarySrc: `url('//cdn0.agoda.net/images/fonts/mallory-light-webfont-v01.eot')`,
            secondarySrc: `url('//cdn0.agoda.net/images/fonts/mallory-light-webfont-v01.eot?#iefix') format('embedded-opentype'),
                url('//cdn0.agoda.net/images/fonts/mallory-light-webfont-v01.woff2') format('woff2'),
                url('//cdn0.agoda.net/images/fonts/mallory-light-webfont-v01.woff') format('woff'),
                url('//cdn0.agoda.net/images/fonts/mallory-light-webfont-v01.ttf') format('truetype')`,
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `url('//cdn0.agoda.net/images/fonts/Mallory-Book.eot')`,
            secondarySrc: `url('//cdn0.agoda.net/images/fonts/Mallory-Book.eot?#iefix') format('embedded-opentype'), 
                url('//cdn0.agoda.net/images/fonts/Mallory-Book.woff2') format('woff2'),
                url('//cdn0.agoda.net/images/fonts/Mallory-Book.woff') format('woff'),
                url('//cdn0.agoda.net/images/fonts/Mallory-Book.ttf') format('truetype')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `url('//cdn0.agoda.net/images/fonts/mallory-medium.eot')`,
            secondarySrc: `url('//cdn0.agoda.net/images/fonts/mallory-medium.eot?#iefix') format('embedded-opentype'),
                url('//cdn0.agoda.net/images/fonts/mallory-medium.woff2') format('woff2'),
                url('//cdn0.agoda.net/images/fonts/mallory-medium.woff') format('woff'),
                url('//cdn0.agoda.net/images/fonts/mallory-medium.ttf') format('truetype')`,
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const pingFangSC: FontFaceTheme = {
    fontFamily: families.pingFangSC,
    fontFaces: [
        {
            primarySrc: `local('PingFangSC-Light')`,
            secondarySrc: `local('PingFangHK-Light-Proportional'), local('PingFang-SC-Light'), local('苹方-Light'), local('萍方-Light')`,
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('PingFangSC-Regular')`,
            secondarySrc: `local('PingFangHK-Regular-Proportional'), local('PingFang-SC-Regular'), local('苹方-Regular'), 
                local('萍方-Regular'), local('pingfang SC')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('PingFangSC-Bold')`,
            secondarySrc: `local('PingFangHK-Bold-Proportional'), local('PingFang-SC-Bold'), local('苹方-Bold'), local('萍方-Bold')`,
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const jhenghei: FontFaceTheme = {
    fontFamily: families.jhenghei,
    fontFaces: [
        {
            primarySrc: `local('Microsoft Jhenghei Light')`,
            secondarySrc: '',
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Microsoft JhengHei Regular')`,
            secondarySrc: `local('Microsoft JhengHei')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Microsoft Jhenghei Bold')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const pingFangTC: FontFaceTheme = {
    fontFamily: families.pingFangTC,
    fontFaces: [
        {
            primarySrc: `local('PingFangTC-Regular')`,
            secondarySrc: `local('PingFangHK-Light-Proportional'), local('PingFang-TC-Light'), local('苹方-Light'), 
                local('萍方-Light')`,
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('PingFangTC-Regular')`,
            secondarySrc: `local('PingFangHK-Regular-Proportional'), local('PingFang-TC-Regular'), local('苹方-Regular'), 
                local('萍方-Regular'), local('pingfang TC')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('PingFangTC-Regular')`,
            secondarySrc: `local('PingFangHK-Regular-Proportional'), local('PingFang-TC-Regular'), local('苹方-Regular'), 
                local('萍方-Regular')`,
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const yahei: FontFaceTheme = {
    fontFamily: families.yahei,
    fontFaces: [
        {
            primarySrc: `local('Microsoft YaHei Light')`,
            secondarySrc: '',
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Microsoft YaHei Regular')`,
            secondarySrc: `local('Microsoft YaHei')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Microsoft YaHei Bold')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const heiti: FontFaceTheme = {
    fontFamily: families.heiti,
    fontFaces: [
        {
            primarySrc: `local('Heiti Light')`,
            secondarySrc: `local('Heiti'), local('方正黑体简体 Light'), local('方正黑体简体')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Heiti Bold')`,
            secondarySrc: `local('方正黑体简体 Bold')`,
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const tahoma: FontFaceTheme = {
    fontFamily: families.tahoma,
    fontFaces: [
        {
            primarySrc: `local('Tahoma Regular')`,
            secondarySrc: `local('Tahoma')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Tahoma Bold')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const thonburi: FontFaceTheme = {
    fontFamily: families.thonburi,
    fontFaces: [
        {
            primarySrc: `local('Thonburi Light')`,
            secondarySrc: '',
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Thonburi')`,
            secondarySrc: '',
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Thonburi Bold')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const msNeogothic: FontFaceTheme = {
    fontFamily: families.msNeogothic,
    fontFaces: [
        {
            primarySrc: `local('Microsoft NeoGothic Regular')`,
            secondarySrc: `local('Microsoft NeoGothic')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Microsoft NeoGothic Bold')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const appleSdGothicNeo: FontFaceTheme = {
    fontFamily: families.appleSdGothicNeo,
    fontFaces: [
        {
            primarySrc: `local('Apple SD Gothic Neo Light')`,
            secondarySrc: `local('Apple SD Gothic Neo')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Apple SD Gothic Neo Bold')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const malgun: FontFaceTheme = {
    fontFamily: families.malgun,
    fontFaces: [
        {
            primarySrc: `local('Malgun Gothic Light')`,
            secondarySrc: `local('맑은 고딕 Light')`,
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Malgun Gothic Regular')`,
            secondarySrc: `local('Malgun Gothic')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Malgun Gothic Bold')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const yuGothic: FontFaceTheme = {
    fontFamily: families.yuGothic,
    fontFaces: [
        {
            primarySrc: `local('Yu Gothic Regular')`,
            secondarySrc: `local('游ゴシック Regular')`,
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Yu Gothic Medium')`,
            secondarySrc: `local('游ゴシック Medium'), local('Yu Gothic')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Yu Gothic Bold')`,
            secondarySrc: `local('游ゴシック Bold')`,
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const meiryo: FontFaceTheme = {
    fontFamily: families.meiryo,
    fontFaces: [
        {
            primarySrc: `local('Meiryo')`,
            secondarySrc: `local('メイリオ')`,
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Meiryo')`,
            secondarySrc: `local('メイリオ')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Meiryo Bold')`,
            secondarySrc: `local('メイリオ Bold')`,
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const hiragino: FontFaceTheme = {
    fontFamily: families.hiragino,
    fontFaces: [
        {
            primarySrc: `local('Hiragino Sans W2')`,
            secondarySrc: '',
            fontWeight: 200,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Hiragino Sans W4')`,
            secondarySrc: `local('Hiragino Sans')`,
            fontWeight: 400,
            fontStyle: 'normal',
        },
        {
            primarySrc: `local('Hiragino Sans W6')`,
            secondarySrc: '',
            fontWeight: 700,
            fontStyle: 'normal',
        },
    ],
};

const faces: FontFaceTheme[] = [
    mallory,
    pingFangSC,
    jhenghei,
    pingFangTC,
    yahei,
    heiti,
    tahoma,
    thonburi,
    msNeogothic,
    appleSdGothicNeo,
    malgun,
    yuGothic,
    meiryo,
    hiragino,
];

export default faces;
